import {
    IDataArray,
    DataArray
} from '../index';


export class EquivalentTranslatedLanguage implements IDataArray {
    public Id = 0;
    public Name: string;
    public Available = false;

    public GetById(): number {
        return this.Id;
    }
}
